// extracted by extract-css-chunks-webpack-plugin
module.exports = {"heading":"default-settings__heading___QK1Cy"};
    if(module.hot) {
      // 1741917344293
      var cssReload = require("../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  